var _rect, _g, _path, _g2, _path2, _path3, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlocked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1928_275539",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1928_275539)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_1928_275539)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1496 134.084C107.978 134.084 134.591 107.471 134.591 74.6423C134.591 41.8136 107.978 15.2007 75.1496 15.2007C42.3209 15.2007 15.708 41.8136 15.708 74.6423C15.708 107.471 42.3209 134.084 75.1496 134.084ZM75.1498 111.399C95.4501 111.399 111.907 94.9426 111.907 74.6423C111.907 54.3419 95.4501 37.8852 75.1498 37.8852C54.8494 37.8852 38.3927 54.3419 38.3927 74.6423C38.3927 94.9426 54.8494 111.399 75.1498 111.399Z",
    fill: "#8DC8E8",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1928_275539",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 120,
    height: 120
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1496 134.084C107.978 134.084 134.591 107.471 134.591 74.6423C134.591 41.8136 107.978 15.2007 75.1496 15.2007C42.3209 15.2007 15.708 41.8136 15.708 74.6423C15.708 107.471 42.3209 134.084 75.1496 134.084ZM75.1497 111.399C95.4501 111.399 111.907 94.9426 111.907 74.6422C111.907 54.3418 95.4501 37.8851 75.1497 37.8851C54.8493 37.8851 38.3926 54.3418 38.3926 74.6422C38.3926 94.9426 54.8493 111.399 75.1497 111.399Z",
    fill: "url(#paint0_linear_1928_275539)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1928_275539)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_1928_275539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.2 86.0557C123.816 80.5952 124.393 77.0698 123.926 71.0449C121.891 44.8154 99.1794 25.1864 73.1986 27.2023C26.9389 30.7917 26.939 73.5176 26.939 81.4699",
    stroke: "url(#paint1_linear_1928_275539)",
    strokeWidth: 24.8508,
    strokeLinecap: "round"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8952 17.8948C21.1508 14.6392 26.4292 14.6392 29.6849 17.8948L132.106 120.316C135.361 123.571 135.361 128.85 132.106 132.105C128.85 135.361 123.572 135.361 120.316 132.105L17.8952 29.6844C14.6396 26.4288 14.6396 21.1504 17.8952 17.8948Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1928_275539",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 120,
    height: 120
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8943 17.8948C21.1499 14.6392 26.4283 14.6392 29.6839 17.8948L132.105 120.316C135.36 123.571 135.36 128.85 132.105 132.105C128.849 135.361 123.571 135.361 120.315 132.105L17.8943 29.6844C14.6386 26.4288 14.6386 21.1504 17.8943 17.8948Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1928_275539)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_diif_1928_275539)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1486 134.084C107.977 134.084 134.59 107.471 134.59 74.6423C134.59 41.8136 107.977 15.2007 75.1486 15.2007C42.3199 15.2007 15.707 41.8136 15.707 74.6423C15.707 107.471 42.3199 134.084 75.1486 134.084ZM75.149 111.399C95.4494 111.399 111.906 94.9426 111.906 74.6422C111.906 54.3418 95.4494 37.8851 75.149 37.8851C54.8486 37.8851 38.3919 54.3418 38.3919 74.6422C38.3919 94.9426 54.8486 111.399 75.149 111.399Z",
    fill: "url(#paint2_linear_1928_275539)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ddiii_1928_275539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.047 103.007C126.182 103.007 131.147 98.0421 131.147 91.9074C131.147 85.7727 126.182 80.8074 120.047 80.8074C113.913 80.8074 108.947 85.7727 108.947 91.9074C108.947 98.0421 113.913 103.007 120.047 103.007Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_1928_275539)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8952 17.8948C21.1508 14.6392 26.4292 14.6392 29.6849 17.8948L132.106 120.316C135.361 123.571 135.361 128.85 132.106 132.105C128.85 135.361 123.572 135.361 120.316 132.105L17.8952 29.6844C14.6396 26.4288 14.6396 21.1504 17.8952 17.8948Z",
    fill: "url(#paint3_linear_1928_275539)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_1928_275539",
    x: 14.1308,
    y: 13.6235,
    width: 120.46,
    height: 121.465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.004
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.00801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-dodge",
    in2: "shape",
    result: "effect1_innerShadow_1928_275539"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.56075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "effect1_innerShadow_1928_275539",
    result: "effect2_innerShadow_1928_275539"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.57723,
    dy: -1.57723
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.29555 0 0 0 0 0.575 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect2_innerShadow_1928_275539",
    result: "effect3_innerShadow_1928_275539"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_1928_275539",
    x: 14.5137,
    y: 13.128,
    width: 122.37,
    height: 86.1092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.50557
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_1928_275539"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.376393,
    dy: 0.752787
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_innerShadow_1928_275539",
    result: "effect2_innerShadow_1928_275539"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_diif_1928_275539",
    x: 5.7667,
    y: 8.06187,
    width: 138.763,
    height: 142.589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.62689
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.97016
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.23575 0 0 0 0 0.5125 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1928_275539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1928_275539",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.65672
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.97016
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.235294 0 0 0 0 0.513726 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_1928_275539"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.65672
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.31344
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1928_275539",
    result: "effect3_innerShadow_1928_275539"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56941,
    result: "effect4_foregroundBlur_1928_275539"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ddiii_1928_275539",
    x: 100.95,
    y: 74.8093,
    width: 42.1939,
    height: 42.1936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.49921,
    dy: 4.99842
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.74882
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.227451 0 0 0 0 0.462745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1928_275539"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.99937,
    dy: 3.99874
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.99842
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.227451 0 0 0 0 0.462745 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1928_275539",
    result: "effect2_dropShadow_1928_275539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1928_275539",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.49921,
    dy: -2.99905
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.74882
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_1928_275539"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.99937,
    dy: -0.999685
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.99937
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_1928_275539",
    result: "effect4_innerShadow_1928_275539"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.64842,
    dy: -4.12104
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.06052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_1928_275539",
    result: "effect5_innerShadow_1928_275539"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_1928_275539",
    x: 15.4531,
    y: 13.9476,
    width: 119.47,
    height: 121.352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.50557
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_1928_275539"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.376393,
    dy: 0.752787
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_innerShadow_1928_275539",
    result: "effect2_innerShadow_1928_275539"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1928_275539",
    x1: 48.9736,
    y1: 45.9626,
    x2: 126.018,
    y2: 39.8651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221D46",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221D46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1928_275539",
    x1: 84.9943,
    y1: 23.4222,
    x2: 119.758,
    y2: 111.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4364C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1928_275539",
    x1: 40.1956,
    y1: -54.9704,
    x2: 218.877,
    y2: 49.5504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1928_275539",
    x1: 57.6003,
    y1: 50.3296,
    x2: 38.6086,
    y2: 78.1081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4364C"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlocked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Blocked.3b33881e182592d72bb1961831711758.svg";